import { Box, BoxProps, Skeleton } from '@chakra-ui/react';
import * as React from 'react';
import { Fragment } from 'react';

export interface FormLoaderProps extends BoxProps {
  button?: boolean;
  label?: boolean;
  textarea?: boolean;
  inputs?: number;
  children?: React.ReactNode;
}
const FormLoader = ({
  inputs = 3,
  textarea,
  label,
  button,
  children,
  ...rest
}: FormLoaderProps): React.ReactElement | null => (
  <Box {...rest}>
    {[...Array(inputs)].map((_, i) => (
      <Fragment key={i}>
        {label ? <Skeleton w="25%" h="18px" mb={1} className="label" /> : null}
        <Skeleton h="50px" mb={6} className="input" />
      </Fragment>
    ))}
    {textarea ? <Skeleton h="120px" mb={6} className="textarea" /> : null}
    {children}
    {button ? <Skeleton h="50px" w="50%" borderRadius="full" className="button" /> : null}
  </Box>
);

export default FormLoader;
